import React from "react";
import { Link, useNavigate } from "react-router-dom";
import defaultProfile from "src/assets/images/default_profile_image.png";
import { useDispatch, useSelector } from "react-redux";
import {
  convertToKebabCase,
  removeToken,
  truncateString,
} from "src/helpers/helperFunctions";
import { removeAuth } from "src/Store/reducer";
import { AppDispatch, RootState } from "@store/store";
import { customer, doctor, doctorMode } from "src/lib/constans";
import Cookies from "js-cookie";
import { removeAllIndicators } from "src/Store/redDots";

interface IProfilePopupProps {
  isProfileModalOpen: boolean;
  setIsProfileModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfilePopup: React.FC<IProfilePopupProps> = ({
  isProfileModalOpen,
  setIsProfileModalOpen,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const mode = Cookies.get(doctorMode) || doctor;
  const { profile } = useSelector((store: RootState) => store.doctor);

  const profileOptions = [
    { option: "Account Settings", url: "/account-settings", isDisplay: true },
    // { option: "Privacy", url: "/privacy", isDisplay: true },
    { option: "Activity Logs", url: "/activity", isDisplay: true },
    {
      option: "Payout & Withdrawal",
      url: "/payouts-withdrawal",
      isDisplay: mode === doctor && userDetails?.userRole === doctor,
    }, // display only dostor site
    { option: "Support Hub", url: "/support-hub", isDisplay: true },
  ];

  const handleSwitchMode = () => {
    Cookies.set(doctorMode, mode === doctor ? customer : doctor);
    navigate("/dashboard");
  };

  const handleLogOut = () => {
    console.log("profilePopup__ handleLogOut");
    Cookies.remove(doctorMode);
    removeToken();
    dispatch(removeAuth());
    dispatch(removeAllIndicators());
    navigate("/doctor/login");
  };

  let padding = `lg:p-[0.6vw_0.7rem] p-[6px_0.5rem]`;

  return (
    <div
      className={`profile-popup-container min-w-[150px] lg:min-w-[16vw] origin-top-right 2xl:rounded-xl xl:rounded-lg rounded-md absolute transition-all duration-300 ${
        isProfileModalOpen ? "scale-100" : "scale-0"
      }`}
    >
      <div className="profile-popup-top">
        <div className="profile-popup-details">
          <div className="profile-img-container">
            <img
              title={`${userDetails?.firstName || ""} ${
                userDetails?.lastName || ""
              }`}
              alt="profile-image"
              width={100}
              height={100}
              className="rounded-full"
              style={{ border: "2px solid #fff" }}
              src={`${userDetails?.coverPhoto}?t=${Date.now()}`}
              onError={(e) => {
                const target = e.target as HTMLImageElement; // Assert the type
                if (target) {
                  target.src = defaultProfile;
                }
              }}
            />
          </div>
          <div className="profile-popup-des">
            <h1 className="title-heading font-Poppins-SemiBold font-size-18px capitalize">{`${
              userDetails?.firstName || ""
            } ${userDetails?.lastName || ""}`}</h1>
            {userDetails?.userRole === doctor ? (
              <>
                <p className="font-size-12px font-Poppins-Regular theme-color-green">
                  {profile?.specailizedDetails
                    ?.map((v, i) => v.name)
                    .join(" | ")}
                </p>
                <p className="font-size-12px font-Poppins-Regular mt-0.5">
                  {profile?.educatuonHistory?.map((v, i) => v).join(", ")}
                </p>
              </>
            ) : (
              <p
                title={userDetails?.headLine || ""}
                className="font-size-12px font-Poppins-Regular"
              >
                {truncateString(userDetails?.headLine || "", 80)}
              </p>
            )}
          </div>
        </div>
        <Link
          to={"/profile-view"}
          id="view-profile-btn"
          className="view-profile-btn font-Poppins-Medium text-center font-size-14px"
        >
          View Profile
        </Link>
      </div>
      <div className="profile-popup-links">
        {/* <span className='font-Poppins-SemiBold mb-[2px] font-size-14px theme-color-green'>Account</span> */}
        {profileOptions
          .filter((item) => item.isDisplay)
          .map((item, index) => (
            <Link
              key={index}
              className={`text-[#464646] font-Poppins-Medium account-setting-hover font-size-14px ${padding}`}
              to={item.url}
              id={`profile-popup-link-${convertToKebabCase(item.option)}`}
            >
              {item.option}
            </Link>
          ))}
        {/* {userDetails?.userRole === doctor && (
          <button
            onClick={handleSwitchMode}
            className={`text-[#464646] font-Poppins-Medium account-setting-hover font-size-14px text-left ${padding}`}
          >
            {mode === doctor
              ? "Switch to Health Profile"
              : "Switch to Doctor Profile"}
          </button>
        )} */}
      </div>
      <div className={`profile-popup-signout ${padding} account-setting-hover`}>
        <button
          id="signout-btn"
          className="text-[#707070] font-Poppins-Medium font-size-14px w-full"
          onClick={handleLogOut}
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default ProfilePopup;
